import { Component, Input, WritableSignal, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { TranslateModule } from '@ngx-translate/core';
import { ImportRecordStatus } from '@vendasta/crm';

export interface ImportStatusBadgeData {
  status?: ImportRecordStatus;
  errorCount?: number;
}

@Component({
  selector: 'crm-import-status-badge',
  imports: [CommonModule, GalaxyBadgeModule, TranslateModule],
  templateUrl: './status-badge.component.html',
})
export class ImportStatusBadgeComponent {
  @Input() set value(cellData: ImportStatusBadgeData) {
    this.importStatus.set(cellData.status ?? null);
    this.importErrorCount.set(cellData.errorCount ?? 0);
  }

  protected readonly importStatus: WritableSignal<ImportRecordStatus | null> = signal(null);
  protected readonly importErrorCount: WritableSignal<number> = signal(0);

  protected readonly importRecordStatusTypes = ImportRecordStatus;
}
